import { createSlice } from '@reduxjs/toolkit'

export const funcionarioSlice = createSlice({
    name: 'funcionario',
    initialState: {
      funcionario: [],
      funcionarioIndividual: []
    },
    reducers: {
      addFuncionario: (state, action) => {
        state.funcionario = action.payload
      },
      addFuncionarioIndividual: (state, action) => {
        state.funcionarioIndividual = action.payload
      },
    },
});

export const { addFuncionario, addFuncionarioIndividual } = funcionarioSlice.actions;
export default funcionarioSlice.reducer;